export enum ChangeReqStatus {
  InProgress = 102,
  Accepted = 202,
  Rejected = 400,
  NeedsInfo = 206,
}
